import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { PoligonDetail } from 'app/models/poligon.model';
import { PoligonService } from 'app/services/poligon.service';
import { SimulationService } from 'app/services/simulation.service';
import { BaseFormComponent } from '../../../base-form.component';
import { SimulationZoneListComponent } from './../zone-list/zone-list.component';

@Component({
    selector: 'app-zone-form',
    templateUrl: './zone-form.component.html',
    styleUrls: ['./zone-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class SimulationZoneFormComponent extends BaseFormComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    private _polygon: Array<PoligonDetail>
    public get model() {
        return this._polygon
    }
    public set model(v: Array<PoligonDetail>) {
        this._polygon = v;
    }

    private _dataSource: MatTableDataSource<PoligonDetail> = undefined;
    public get dataSource(): MatTableDataSource<PoligonDetail> {
        return this._dataSource;
    }

    private _displayedColumns = ['name','deviceId', 'neighbor', 'street', 'site', "setting"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _simulationService: SimulationService,
        public dialogRef: MatDialogRef<SimulationZoneListComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
        super();
    }


    public async ngOnInit() {
        this.GetPoligonDetails();
    }
    public async GetPoligonDetails() {
        try {
            this._polygon = await this._simulationService.getPoligonDetail(this.data.id);
        } catch (error) {
            console.warn(error);

        }
        this.updateTableDataSource();
    }
    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<PoligonDetail>(this._polygon);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }
    public async deletePolygonDetail(poligonDetail: PoligonDetail) {
        try {
            await this._simulationService.deletePoligonDetail(poligonDetail);

        } catch (error) {
            console.warn(error);

        }
        this.refresh();
    }
    refresh() {
        this.GetPoligonDetails();
    }
}
